import { PropsWithChildren, useState } from 'react';

import { Button, Icons, Stack } from '@cast/design-system';

import type { StackProps } from '@cast/design-system';

type QuickSearchProps = PropsWithChildren<{
  containerProps?: StackProps;
  defaultOpen?: boolean;
  testId?: string;
}>;

export const QuickSearch = ({
  containerProps,
  children,
  defaultOpen = false,
  testId,
}: QuickSearchProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Stack gap={4} data-testid={testId ?? 'quick-search'}>
      <Button
        variant="text"
        size="sm"
        endIcon={isOpen ? <Icons.CaretDoubleUp /> : <Icons.CaretDoubleDown />}
        onClick={() => setIsOpen(!isOpen)}
        testId="quick-search-toggle"
      >
        Quick search
      </Button>
      {isOpen && (
        <Stack
          direction="row"
          gap={8}
          flexWrap="wrap"
          data-testid="quick-search-container"
          alignItems="flex-end"
          {...containerProps}
        >
          {children}
        </Stack>
      )}
    </Stack>
  );
};
